import LastMenu from "../ChatFlow/Lastmenu";
const Locations = () =>{
    return(
        <>
        <>
        
            <div className="frame1" style={{textAlign: 'center'}}>
            <a href="https://www.medicoverhospitals.in/hospitals/telangana/hyderabad/hitec-city/" target="_blank" rel="noopener noreferrer">
                <button className="detatils-button2">Hitech City</button>
            </a>
            <a href="https://www.medicoverhospitals.in/hospitals/andhra-pradesh/srikakulam/" target="_blank" rel="noopener noreferrer">
                <button className="detatils-button2">Srikakulam</button>
            </a>
            <a href="https://www.medicoverhospitals.in/hospitals/maharashtra/pune/" target="_blank" rel="noopener noreferrer">
                <button className="detatils-button2">Pune</button>
            </a>
            <a href="https://www.medicoverhospitals.in/hospitals/karnataka/bengaluru/" target="_blank" rel="noopener noreferrer">
                <button className="detatils-button2">Banglore</button>
            </a>
            </div>
            
            <LastMenu/>
            </>
        
            
        </>
        
    );
}
export default Locations;